// GumastaLicense.jsx
import React from "react";

export default function GumastaLicense() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Gumasta License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Gumasta License (Shop & Establishment Registration)
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining a Gumasta
            License (Shop and Establishment Registration) in compliance with
            state labor laws and local municipal regulations.
          </p>
          <p className="text-gray-700">
            From identifying the correct state-specific authority and preparing
            the online application to organizing supporting documents and
            following up on approvals, the process is handled efficiently so
            your commercial establishment can operate legally.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Shop establishment registration and business compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Gumasta License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile and organize the essential
              identity, business, and premises proofs required for Shop and
              Establishment Registration across different states.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of proprietor, partners, or company directors.</li>
                <li>
                  Identity and address proof of applicant (Aadhaar, Voter ID,
                  Passport, or Driving License).
                </li>
                <li>
                  Business premises address proof (rent agreement, ownership
                  documents, utility bill, or municipal tax receipt).
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers specialized support for Shop and Establishment
              registrations with state-specific expertise and a focus on
              seamless compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  State-wise Shop & Establishment Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Knowledge of each state&apos;s labor department procedures,
                  online portals, document formats, and registration timelines to
                  ensure smooth processing.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Smooth and Compliant Registration Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end assistance from eligibility assessment and
                  documentation to online filing, corrections, and license
                  issuance with full compliance assurance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  Reliable handling of state-specific variations, follow-ups
                  with labor authorities, and post-registration compliance
                  advisory for ongoing obligations.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
